import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { scrollToSection as scrollTo } from "@/lib/scroll";
import { Truck, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer id="contact" className="bg-white border-t border-slate-200 pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center w-9 h-9 rounded-lg bg-ksy-navy text-white"><Truck className="w-5 h-5" /></span>
              <span className="font-display font-extrabold text-lg text-ksy-navy">KS&amp;Y Transport LLC</span>
            </div>
            <p className="mt-4 text-slate-500 max-w-sm leading-relaxed">{t("footer.tagline")}</p>
            <div className="mt-5 flex items-center gap-2 text-sm text-slate-400">
              <MapPin className="w-4 h-4" /> Serving all 48 contiguous states
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-bold uppercase tracking-wider text-ksy-navy mb-4">{t("footer.contact")}</h4>
            <a href="mailto:contact@ksytransport.com" className="flex items-center gap-3 text-slate-600 hover:text-ksy-blue transition-colors mb-3" data-testid="footer-email">
              <Mail className="w-4 h-4" /> contact@ksytransport.com
            </a>
            <a href="tel:8069302872" className="flex items-center gap-3 text-slate-600 hover:text-ksy-blue transition-colors" data-testid="footer-phone">
              <Phone className="w-4 h-4" /> (806) 930-2872
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-bold uppercase tracking-wider text-ksy-navy mb-4">{t("footer.quick")}</h4>
            <div className="flex flex-col gap-2.5">
              <button onClick={() => scrollTo("services")} className="text-left text-slate-600 hover:text-ksy-blue transition-colors" data-testid="footer-nav-services">{t("nav.services")}</button>
              <button onClick={() => scrollTo("quote")} className="text-left text-slate-600 hover:text-ksy-blue transition-colors" data-testid="footer-nav-quote">{t("nav.quote")}</button>
              <button onClick={() => scrollTo("drivers")} className="text-left text-slate-600 hover:text-ksy-blue transition-colors" data-testid="footer-nav-drivers">{t("nav.drivers")}</button>
              <Link to="/admin/login" className="text-left text-slate-600 hover:text-ksy-blue transition-colors" data-testid="footer-admin-link">{t("nav.admin")}</Link>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-slate-200 flex flex-col sm:flex-row justify-between gap-3">
          <span className="text-sm text-slate-400">© {new Date().getFullYear()} KS&amp;Y Transport LLC. {t("footer.rights")}</span>
          <span className="text-sm text-slate-400">USDOT & MC Certified · Fully Insured</span>
        </div>
      </div>
    </footer>
  );
}
